import React, { useState, useEffect } from "react";
import sanityClient from "../client.js";

export default function Projects() {
  // Create useState and useEffect
  const [projectData, setProjectData] = useState(null);

  // Fetch data from sanityClient with useEffect
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "project"]{
      title,
      date,
      place,
      description,
      projectType,
      link,
      tags,
      mainImage {
        asset->{
          _id,
          url
        },
        alt
      },
    }`
      )
      .then((data) => setProjectData(data))
      .catch(console.error);
  }, []);

  if (!projectData) {
    return (
      <div className="flex justify-center p-40 loading-text">Loading...</div>
    );
  }

  return (
    <main>
      <section>
        <div className="project-container">
          {/* Map project data and its index */}
          {projectData &&
            projectData.map((project, index) => (
              <span className="project-item">
                <div className="project-text-container">
                  <strong>
                    <h2>{project.title}</h2>
                  </strong>
                  <span>
                    <strong>Finished on:</strong>{" "}
                    {new Date(project.date).toLocaleDateString()}
                  </span>
                  <span style={{ marginLeft: 10 }}>
                    <strong>Type:</strong> {project.projectType}
                  </span>
                </div>

                <div className="project-image-container">
                  <img
                    src={project.mainImage.asset.url}
                    alt={project.mainImage.alt}
                    style={{ objectFit: "cover" }}
                  />
                </div>

                <div className="project-text-container">
                  <p>{project.description}</p>
                  <a
                    href={project.link}
                    alt={project.title}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="go-to-project"
                  >
                    Go To The Project
                  </a>
                </div>
              </span>
            ))}
        </div>
      </section>
    </main>
  );
}
